import React, { useState } from "react";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import dompurify from "dompurify";

import PageWrapper from "../../PageWrapper";
import PrimaryButton from "../../SFUCentralThemedComponents/PrimaryButton";

import { getScholarshipId } from "../../../utils/auth/authSlice";
import { useScholarshipId } from "../../../hooks/useScholarshipId";

import LoadingPage from "../../LoadingPage";

export default function InitialInformationPage({ scholarshipType }) {
  const [formikInitialErrors] = useState({});
  const [formikInitialTouched] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  dispatch(getScholarshipId({ scholarshipType }));

  const scholarshipData = useScholarshipId();

  if (scholarshipData.isLoading) {
    return <LoadingPage />;
  }

  return (
    <PageWrapper>
      <Formik
        initialErrors={formikInitialErrors}
        initialTouched={formikInitialTouched}
      >
        {() => (
          <Form>
            <div className="p-grid">
              <div className="p-col-12">
                {scholarshipData.data.application_first_page_text ? (
                  // eslint-disable-next-line react/no-danger
                  <div
                    dangerouslySetInnerHTML={{
                      __html: dompurify.sanitize(
                        scholarshipData.data.application_first_page_text
                      ),
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="p-grid button-navigation-container">
              <div className="p-col-12">
                <PrimaryButton
                  type="button"
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  Begin Application
                </PrimaryButton>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}
